<template>
  <div>
    <BreadCrumb v-if="this.mode !== 'comp'" :data="breadCrumb" />
    <Table
      :fields="fields" :items="stockList" :filtered="filtered" type="List" 
      :loading="isLoading" :limit="limit" :setLimit="setLimit" :page="page" :setPage="setPage" 
      :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" :goDetail="goEdit" 
      :inputs="inputs" :search="search" :gSearch='gSearch' addUrl="Stock/Add"
    />

    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" 
      :form="currentForm" :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import Table from "@/components/Table";
import Modals from "./modals/";
// import i18n from "@/plugins/i18n";

let breadCrumb = [{ label: "Stoklar", url: "/Stock/List" }];

let fields = [
  { key: "barcode", label: "Stok Kodu", keys: ["barcode"] },
  { key: "name", label: "Adı", keys: ["name"] },
  { key: "unit", label: "Birim", keys: ["unit"] },
  { key: "quantity", label: "Mevcut Adet", keys: ["quantity"] },
  { key: "active", label: "Durum", keys: ["active"] },
  { key: "actions", label: "İşlemler" },
];
let inputs = [
  { key: "barcode", label: "Stok Kodu", type: "Number", checked: false, val: "" },
  { key: "name", label: "Stok Adı", type: "String", checked: false, val: "" },
  { key: "isActive", label: "Durum", type: "Select",checked: false,val: "", array: [
      { text: "Aktif", value: true },
      { text: "Pasif", value: false }
    ]},
  {key: "quantity",label: "Mevcut Adet",type: "String",checked: false,val: "",},
  { key: "unit", label: "Birim", type: "String", checked: false, val: "" },
];
let actions = [
  { key: "active", text: "Aktif Et", active: true },
  { key: "passive", text: "Pasif Et", active: false },
  { key: "delete", text: "Sil" },
];
let filtered = ["barcode", "name", "unit", "quantity", "active", "actions"];

export default {
  name: "StockList",
  watch: {
    limit(val) {
      this.params["limit"] = val;
      this.$store.dispatch("stock_get", this.params);
    },
    offset(val) {
      this.params["offset"] = val;
      this.$store.dispatch("stock_get", this.params);
    },
  },
  data: function () {
    return {
      breadCrumb, fields, filtered, limit: 10, page: 1, offset: 0, actions,
      modalOpen: false, modalProps: {}, currentForm: "Stock", modalName: "",
      dismissCountDown: 0, inputs,
      params: {
        limit: 10,
        offset: 0,
      },
    };
  },
  components: {
    BreadCrumb,
    Table,
    Modals
  },
  props: {
    mode: String,
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    stockList() {
      return this.$store.getters.stockList
    },
    pageInfo(){
      return this.$store.getters.getStockPageInfo
    }
  },
  methods: {
    search(){
      this.inputs.map((input) => {
        input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
      })
      this.$store.dispatch('stock_get', this.params)
    },
    gSearch(data){
      data.length > 0 ? this.params['search'] = data : delete this.params['search']
      this.$store.dispatch('stock_get', this.params)
    },
    goEdit(item) {
      this.$router.push({ path: `/Stock/${item.id}/Edit` });
    },
    setLimit: function (limit) {
      this.limit = limit;
      this.params.limit = limit;
    },
    setPage: function (page) {
      if (page > 0) {
        this.page = page;
        this.params.offset = (page - 1) * this.limit;
        this.$store.dispatch("stock_get", this.params);
      }
    },
    actionEvent: async function (key, data) {
      if (key == 'active') {
        this.openModal(true, "SetState", {  ...data, state: true, type: 'state' });
      } 
      if (key == 'passive') {
        this.openModal(true, "SetState", { ...data, state: false, type: 'state'});
      }
      if (key == 'delete') {
        this.openModal(true, "delete", data);
      }
    },
    openModal: function(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalProps = props
        this.modalName = modal
      }
    },
  },
  created() {
    this.$store.dispatch("stock_get", this.params);
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/List.vue